// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e148d8a1c6562fdec0f43e447049963cb6474919.chunk.bundle.js";
};